
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"13","viewBox":"0 0 10 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":"0.6","fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.375 0.499977C0.61875 0.499977 0.006875 1.12998 0.006875 1.89998L0 11.1C0 11.87 0.611875 12.5 1.36812 12.5L8.6251 12.5C9.38135 12.5 10.0001 11.87 10.0001 11.1V5.281C10.0001 4.91 9.85572 4.553 9.59447 4.294L6.27385 0.913002C6.01947 0.647002 5.66885 0.500002 5.30447 0.500002L1.375 0.499977ZM5.0001 4.77273V1.5L9.0001 5.5H5.72737C5.32737 5.5 5.0001 5.17273 5.0001 4.77273Z","fill":"#00A769"}})])
          )
        }
      }
    